import type { CalendarToastState } from "../hooks/useChangeQueue";
import { WarnIcon } from "./CalendarIcons";
import styles from "./CalendarModule.module.css";

/** The mockup's toast: what just changed, with Undo while nothing has been sent. */
export function CalendarToast({ toast }: Readonly<{ toast: CalendarToastState | null }>) {
  if (!toast) return null;
  const content = (
    <>
      {toast.warning && (
        <span className={styles.toastIcon}>
          <WarnIcon />
        </span>
      )}
      <span className={styles.toastText}>{toast.message}</span>
      {toast.onUndo && (
        <button type="button" className={styles.toastAction} onClick={toast.onUndo}>
          Undo
        </button>
      )}
    </>
  );
  // An error interrupts (alert); anything else is a polite status, which <output> is.
  return toast.kind === "error" ? (
    <div className={`${styles.toast} ${styles.toastError}`} role="alert">
      {content}
    </div>
  ) : (
    // An invite to someone outside the organisation is still a polite status, styled as a warning.
    <output className={toast.warning ? `${styles.toast} ${styles.toastWarning}` : styles.toast}>{content}</output>
  );
}
